import React from 'react';
import { COLORS, FONTS } from '@app/constants';
import { useTranslation } from 'react-i18next';
import { Column } from '@/styles/reactnative';
import styled from 'styled-components';
import BotButtonCointaner from './BotButtonCointaner';

const GradientText = styled.div`
  background: linear-gradient(90deg, #07d993 0%, #ffcc0d 50%, #ff8a00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  display: block;
  font-family: ${FONTS.h1.fontFamily || 'Aggro, sans-serif'};
  font-size: 48px;
  line-height: 60px;
  font-weight: bold;
  letter-spacing: -0.96px;
`;

const WhiteText = styled.div`
  display: block;
  font-family: ${FONTS.h1.fontFamily || 'Aggro, sans-serif'};
  font-size: 42px;
  line-height: 60px;
  font-weight: bold;
  letter-spacing: -0.84px;
  color: ${COLORS.white};
`;

const HighlightSpan = styled.span`
  color: #07d993;
`;

const TradingBotLeftSide = () => {
  const { t } = useTranslation();
  return (
    <Column alignItems={'flex-start'}>
      <GradientText>{t('botEventTitleLine1')}</GradientText>
      <WhiteText>{t('botEventTitleLine2')}</WhiteText>
      <WhiteText>
        {t('botEventTitleLine3')}{' '}
        <HighlightSpan>{t('botEventTitleLine3Highlight')}</HighlightSpan>
      </WhiteText>

      <BotButtonCointaner />
    </Column>
  );
};

export default TradingBotLeftSide;
